module.exports = __webpack_public_path__ + "first-20_microprint.jpg?72acff9971607ba9f2f51fa8ed29ac94";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20_microprint.jpg
// module id = 501
// module chunks = 0